import { Injectable } from '@angular/core';
import { Observable, Subject, from } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface ATMEvent {
  name: EventType;
  data: ATMEventData;
}

@Injectable()
export class EventBusService {
  private events: Subject<ATMEvent>;

  constructor() {
    this.events = new Subject<ATMEvent>();
  }

  public fireEvent(event: EventType, eventData: ATMEventData): void {
    this.events.next({ name: event, data: eventData });
  }

  public getEventBus(event: EventType): Observable<ATMEventData> {
    return from(this.events).pipe(filter(m => m.name === event), map(m => m.data));
  }
}

export class ATMEventData {
  constructor(public data: any, public getString: Function, public disableFlash?: boolean) {}
}

export enum EventType {
  AUTHORITY_POLL_EVENT,
  AUTHORITY_UPDATED_EVENT,
  NOTIFICATION_POLL_EVENT,
  BLOCK_UI_EVENT,
  RELEASE_UI_EVENT,
  SUCCESS_EVENT,
  NOTIFY_FAILURE_EVENT,
  NOTIFY_SUCCESS_EVENT,
  SET_OUTAGE_EVENT,
  CLEAR_OUTAGE_EVENT,
  ONLINE_EVENT,
  OFFLINE_EVENT,
  SYSTEM_ENABLED_EVENT,
  SYSTEM_DISABLED_EVENT,
  OKTA_LOGIN_SUCCESS,
  RESET_POLL_EVENT,
  NOTIFY_SUCCESS_OFFLINE,
  NOTIFY_PENDING_OFFLINE,
  NOTIFY_FAILURE_OFFLINE,
  NOTIFY_FAILURE_BROWSER_OFFLINE,
  REGULARMAINTENANCE,
  REGULARMAINTENANCE_CLEARED,
  SET_USER_ALERT_EVENT,
  CLEAR_USER_ALERT_EVENT
}
